import _ from 'lodash';

import { getCountryCode } from '../../lendingAPI/lendingAPISelector';

export const getCompanyTypeFromForm = (state) => {
    const companyTypeFromForm = _.get(
        state,
        'form.sign_up.businessType.company.type.value'
    );

    return companyTypeFromForm;
};

export const hasPendingDocuments = (offer) => {
    return offer === 'pending_documents';
};

export function hasRequiredDocuments(offer) {
    return offer.data_requirements.some(
        (dataRequirement) =>
            dataRequirement.category === 'documents' &&
            dataRequirement.actions.some(
                (action) => !action.is_optional && action.status === 'required'
            )
    );
}

export const getApprovalRequirementErrors = (offer) => {
    if (!offer.data_requirements) {
        return [];
    }

    return offer.data_requirements.flatMap((dataRequirement) =>
        dataRequirement.actions.flatMap((action) =>
            action.resolution_methods.flatMap((resolutionMethod) =>
                resolutionMethod.errors.map((error) => error.code)
            )
        )
    );
};

export const hasOffer = (product) =>
    !!(product && product.offers && product.offers.length);

export const isDeclined = (product) =>
    _.includes(
        [
            'hard_declined',
            'soft_declined',
            'automatically_rejected',
            'approval_requirement_auto_declined'
        ],
        product.status
    );

export const isCountryDE = (state) => getCountryCode(state) === 'de';

export const isPendingManualDecision = (product) =>
    _.includes(
        [
            'credit_assessment_required',
            'credit_assessment_pending', // Possibly not used
            'pending_document_review',
            'approval_requirement_declined',
            'credit_assessment_amount_less_than_product_key'
        ],
        _.get(product, 'status')
    );

export const getCurrentStep = (state) => _.get(state, 'ui.activeStep.id');

export const getProductDeclineUid = (product) =>
    _.get(product, 'product_type_decline.uuid');

export function getMaxAmountOffer(offers) {
    if (offers && offers.length > 0) {
        const offerWithHighestAmount = offers?.reduce(function (prev, current) {
            return prev.amount > current.amount ? prev : current;
        });

        return offerWithHighestAmount;
    }
}
